import * as History from 'history';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as pbi from 'powerbi-client';
import { parse, stringify } from 'qs';
import * as React from 'react';
import { bind } from '../Utils/Bind';
import { BiReport, IBiReportProps } from './BiReport';

export interface IBiDashboardProps extends IBiReportProps {
    history: History.History;
    location: History.Location;
}

@observer
export class BiDashboard extends React.Component<IBiDashboardProps> {
    public render() {
        return <BiReport {...this.reportProps} />;
    }

    @computed
    private get reportProps(): IBiReportProps {
        return {
            ...this.props,
            onTileClicked: this.onTileClicked,
        };
    }

    @bind
    private onTileClicked(event: pbi.service.ICustomEvent<any>) {
        const navUrl = event.detail.navigationUrl;
        const reportId = navUrl.substring(navUrl.lastIndexOf('reports/') + 8, navUrl.lastIndexOf('/ReportSection'));

        this.props.history.push({
            pathname: '/bi/reports/' + reportId,
        });
    }
}
